// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"155fd6ee","214":"155fd6ee","516":"155fd6ee","964":"1b710c04"}[chunkId] + ".chunk.css";
};